import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import MainLayout from '../components/MainLayout';
import ProfileCard from '../components/ProfileCard';
import ProfileForm from '../components/ProfileForm';
import SecurityForm from '../components/SecurityForm';
import { useProfileStore } from '../store/profileStore';
import usePageTitle from '../utils/usePageTitle';
import { useGlobalLoading } from '../hooks/useGlobalLoading';

interface CardsContainerProps {
  $visible: boolean;
}

const CardsContainer = styled.div<CardsContainerProps>`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  width: 100%;
  max-width: 100%;
  opacity: ${props => props.$visible ? '1' : '0'};
  transition: opacity 0.3s ease;
`;

const Profile: React.FC = () => {
  usePageTitle('Профиль');

  const { isFetching, fetchProfile } = useProfileStore();
  const { addLoadingStep, removeLoadingStep } = useGlobalLoading();
  const [isVisible, setIsVisible] = useState(false);
  const [isDataReady, setIsDataReady] = useState(false);

  // Управляем глобальной загрузкой
  useEffect(() => {
    if (isFetching) {
      addLoadingStep('profile-loading', 'Загружаем ваш профиль...', 5);
    } else {
      removeLoadingStep('profile-loading');
    }
  }, [isFetching, addLoadingStep, removeLoadingStep]);

  // Загружаем данные профиля при монтировании компонента
  useEffect(() => {
    fetchProfile()
      .then(() => {
        setIsDataReady(true);
      });
  }, [fetchProfile]);

  // Плавно отображаем контент после загрузки данных
  useEffect(() => {
    if (isDataReady && !isFetching) {
      setTimeout(() => {
        setIsVisible(true);
      }, 100);
    } else {
      setIsVisible(false);
    }
  }, [isDataReady, isFetching]);

  return (
    <MainLayout activePage="profile">
      <div data-tutorial="profile-header">
        <CardsContainer $visible={isVisible}>
          <div data-tutorial="profile-card">
            <ProfileCard title="Основная информация">
              <div data-tutorial="edit-profile-form">
                <ProfileForm />
              </div>
            </ProfileCard>
          </div>

          <div data-tutorial="security-form">
            <ProfileCard title="Безопасность">
              <SecurityForm />
            </ProfileCard>
          </div>
        </CardsContainer>
      </div>
    </MainLayout>
  );
};

export default Profile; 